import { GenericStatus } from './generic-status';
import { HevoEntityMeta, RawHevoEntityMeta } from './entity-meta';
import { RawIntegration } from './integration';
import { EntityAction, EntityRawAction } from '../../entity-actions/interfaces/entity-actions';

export enum DestinationStatus {
  FAILED = 'FAILED',
  CREATED = 'CREATED',
  DELETING = 'DELETING',
  DELETED = 'DELETED',
  DELETE_FAILED = 'DELETE_FAILED'
}

export interface DestinationType {
  destinationType: string;
  baseDestinationType?: string;
  displayName: string;
  id: string | number;
  description: string;
  version?: string;
  logo: string;
  logoDarkMode: string;
  documentationLink?: string;
}

export interface Destination extends HevoEntityMeta {
  id: number;
  seqId: number;
  name: string;
  destinationType: DestinationType;
  status: GenericStatus<DestinationStatus>;
  actions: EntityAction<DestinationAction>[];
  integrationsCount?: number;
}

export interface RawDestinationType {
  type: string;
  display_name: string;
  logo_url: string;
  dark_mode_logo_url: string;
  description: string;
  doc_link: string;
  base_type: string;
  version: string;
  properties?: {
    [key: string]: unknown;
  };
}

export interface RawDestination extends RawHevoEntityMeta {
  id: number;
  seq_id: number;
  name: string | null;
  destination_type: RawDestinationType;
  status: {
    type: DestinationStatus;
    display_text: string;
    hover_text?: string;
  };
  integrations?: RawIntegration[] | null;
  destination_actions?: EntityRawAction<DestinationAction>[];
  integrations_count?: number;
}

export interface DestinationPrefixValidationRequest {
  destinationPrefix: string;
  destinationType: string;
}

export interface DestinationPartitionKeyValidationRequest {
  destinationPartitionKey: string;
}

export enum DestinationAction {
  DELETE = 'DELETE',
  EDIT = 'EDIT'
}
